import Vue from "vue"
import VueCamVision from "vue-cam-vision"

Vue.use(VueCamVision)
Vue.component("WebCam", VueCamVision)

export default VueCamVision